// extracted by mini-css-extract-plugin
export default {"viewportSmallMediumMax":"962px","noticeBar":"noticeBar-1ozWeq","slideIn":"slideIn-1dVoQn","slideOut":"slideOut-1FcO_P"};